import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";


const BloodPressureDash = (props) => {
const BPChart = Array.isArray(props?.homePageCharts) ? props.homePageCharts : [];
const filteredBPChart = BPChart
  .filter(item => item.indicatornames.includes('Blood pressure'))
  .map(item => {
    // Split the indicatornames by '-' and take the first part
    const parts = item.indicatornames.split('-');
    return {
      counts: item.counts,
      indicatornames: parts[0]
    };
  });

const BPIndicatorNames = filteredBPChart.map(item => item.indicatornames);

// Predefined colors for BMI categories
const bpColors = {
    "Good control": "#8ec5d5",
    "Needs Attention": "#001c58",
    "Poor control": "#004f88",
    "Normal Range": "#00b0f0",
  };
  
  // Filtering and mapping BP-related entries
const BPData = BPChart
.filter(item => item.indicatornames.includes('Blood pressure'))
.map(item => {
  // Extract the part after 'Blood pressure' and split by space
  const indicator = item.indicatornames.split('Blood pressure ')[0].split('-')[0];
  return { y: item.counts, color: bpColors[indicator] || '#cccccc' }; // Default color if not found
});


  const barChart1 = {
    chart: {
      type: 'bar',
      backgroundColor: null,
      height:'320',
  },
  title: {
      text: '',
      align: 'left'
  },
  xAxis: {
        categories: BPIndicatorNames,
      title: {
          text: null
      },
      gridLineWidth: 1,
      lineWidth: 0
  },
  yAxis: {
      min: 0,
      title: {
          text: '',
          align: 'high'
      },
      labels: {
          enabled: false,
      },
      gridLineWidth: 0
  },
  tooltip: {
  },
  plotOptions: {
      bar: {
          dataLabels: {
              enabled: true
          },
          groupPadding: 0,
      }
  },
  legend: {
      enabled: false
  },
  credits: {
      enabled: false
  },
  series: [{
    name: 'Count',
    data:BPData,
  }]
  };

  return <HighchartsReact highcharts={Highcharts} options={barChart1} />;
};

export default BloodPressureDash;